import { Dialog, Transition } from "@headlessui/react";
import React, { FC, Fragment } from "react";
import CloseIcon from "../../icons/close";
import { Trans } from "react-i18next";

export type DeletePopupPropType = {
  deleteEvent: (value: boolean) => void;
  open: boolean;
  setOpen: (value: boolean) => void;
};

const DeletePopup: FC<DeletePopupPropType> = ({
  deleteEvent,
  open,
  setOpen,
}) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-20" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex h-full items-center justify-center ">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden flex items-center rounded-lg px-[20px] pt-5 pb-4 text-left shadow-xl transition-all w-[500px] h-[200px] bg-white">
                <div className=" py-2 px-4 w-full ">
                  <p className="font-normal text-xl">
                    <Trans>Are you sure you want to delete this event?</Trans>
                  </p>
                  <div className="flex justify-between items-center pt-8 ">
                    <button
                      type="button"
                      className="px-7 py-2 rounded-full text-white bg-[#1E408E] uppercase"
                      onClick={() => deleteEvent(true)}
                    >
                      <Trans>Yes</Trans>
                    </button>
                    <button
                      type="button"
                      className="px-7 py-2 rounded-full text-white bg-[#1E408E] uppercase"
                      onClick={() => deleteEvent(false)}
                    >
                      <Trans>No</Trans>
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default DeletePopup;
